import {
    LIST_SERVERS,
    LIST_SERVERS_SUCCESS,
    LIST_SERVERS_ERROR,
    ADD_SERVERS,
    SAVE_SERVERS,
    SAVE_SERVERS_SUCCESS,
    SAVE_SERVERS_ERROR,
    EDIT_SERVERS,
    UPDATE_SERVERS,
    UPDATE_SERVERS_SUCCESS,
    UPDATE_SERVERS_ERROR,
    DELETE_SERVERS,
    DELETE_SERVERS_SUCCESS,
    DELETE_SERVERS_ERROR
} from '../types';

//Cada reducer tiene su propio state
const initialState = {
    servers: null,
    error: null,
    loading: false,
    serverSelected: null,
    isEdit: false,
    loadingSave: false,
    errorSave: null
}

export default function(state = initialState, action) {
    switch(action.type){
        case LIST_SERVERS:
            return {
                ...state,
                loading: true
            }
        case LIST_SERVERS_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case LIST_SERVERS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                servers: action.payload
            }
        case SAVE_SERVERS:
        case DELETE_SERVERS:
            return {
                ...state,
                isEdit: false,
                loadingSave: true
            }
        case UPDATE_SERVERS:
            return {
                ...state,
                loadingSave: true
            }
        case SAVE_SERVERS_ERROR:
        case UPDATE_SERVERS_ERROR:
        case DELETE_SERVERS_ERROR:
            return {
                ...state,
                loadingSave: false,
                errorSave: action.payload
            }
        case SAVE_SERVERS_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                servers: [...state.servers, action.payload]
            }
        case ADD_SERVERS:
            return {
                ...state,
                serverSelected: null,
                isEdit: false
            }
        case EDIT_SERVERS:
            return {
                ...state,
                serverSelected: action.payload,
                isEdit: true
            }
        case UPDATE_SERVERS_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                servers: state.servers.map(server => 
                    server.id === action.payload.id ? server = action.payload : server
                ),
                serverSelected: null
            }
        case DELETE_SERVERS_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                servers: state.servers.filter( server => server.id !== action.payload)
            }
        default:
            return state;
    }
}